import React, { useEffect, useState } from 'react'
import { Box, FormControl, InputLabel, MenuItem, Paper, Select } from '@mui/material'
// import { SelectChangeEvent } from '@mui/material/Select'
import { useTranslation } from 'react-i18next'
import { useLocation, useNavigate, createSearchParams } from 'react-router-dom'
import useSWR from 'swr'

import { ProtectedPage } from '~/src/components/templates'
import { LoadingNormal, ContainerOrder } from '~/src/components/organisms'
import { SectionTitle } from '~/src/components/molecules'

import { useMessage } from '~/src/hooks'
import { containerRepository } from '~/src/repositories'
import { IQuery as IContainerQuery } from '~/src/repositories/Container/schema/Container'
import { useUsers } from '~/src/hooks/useApi'

/**
 * ContainerOrderList
 * @constructor
 */
export const ContainerOrderList: React.VFC = (): JSX.Element => {
  const { t } = useTranslation()
  const { handleOpenWithErrorMessage } = useMessage()
  const navigate = useNavigate()
  const location = useLocation()

  const [params, setPrams] = useState<IContainerQuery>(
    // @ts-ignore
    location.state && location.state.prevState
      ? // @ts-ignore
        (location.state.prevState as IContainerQuery)
      : location.state
      ? (location.state as IContainerQuery)
      : ({} as IContainerQuery)
  )
  // phase 3
  // const [userId, setUserId] = useState<string>(String(params.userId) || '')

  const { data: users, error: usersError } = useUsers({ limit: 1000000 }) // 一回で全て取得するために適当に大きな数字
  const [options, setOptions] = useState<{ id: number; name: string }[]>([])
  const { data, error } = useSWR(['/containers', params], () =>
    containerRepository.getContainers(params)
  )

  useEffect(() => {
    if (error || usersError) handleOpenWithErrorMessage(error.message || usersError.message)
  }, [error, usersError])

  useEffect(() => {
    if (users) {
      setOptions(users.items.map((user) => ({ id: user.id!, name: user.name || 'no name' })))
    }
  }, [users])

  /**
   *phase 3
  const handleChange = (event: SelectChangeEvent): void => {
    setUserId(event.target.value)
    setPrams({ ...params, userId: Number(event.target.value) })
  }
   **/

  /**
   * fetchContainerOrder
   * @param _params
   */
  const fetchContainerOrder = async (_params?: IContainerQuery): Promise<void> => {
    let mergedParams = _params
    if (location.state) {
      // @ts-ignore
      mergedParams = { ...location.state, ..._params }
    }
    // @ts-ignore
    setPrams(mergedParams)
    navigate(
      {
        pathname: location.pathname,
        // @ts-ignore
        search: `?${createSearchParams(mergedParams)}`,
      },
      { state: mergedParams }
    )
  }

  return (
    <ProtectedPage pageTitle={t('container_order.container_order')}>
      {/*
      <Box sx={{ minWidth: 120, maxWidth: 220, background: '#FFFFFF', marginBottom: '24px' }}>
        <FormControl fullWidth size="small">
          <InputLabel id="container-order-list-select-label" sx={{ fontSize: '16px' }}>
            {t('container_order.filter')}
          </InputLabel>
          <Select
            sx={{
              fontSize: '16px',
              fontStyle: 'normal',
              background: 'white',
              '&.MuiOutlinedInput-root': {
                '&>div': {
                  '&.MuiSelect-select': {
                    maxHeight: '40px',
                  },
                },
              },
            }}
            labelId="container-order-list-select-label"
            id="container-order-list-select-label"
            value={userId}
            label={`${t('container_order.filter')}`}
            onChange={handleChange}
          >
            {options.map((option) => (
              <MenuItem key={option.id} value={option.id}>
                {option.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Box>
      */}
      <Paper sx={{ boxShadow: 'none' }}>
        <SectionTitle>{t('container_order.container_order')}</SectionTitle>
        {!data ? (
          <LoadingNormal />
        ) : (
          <ContainerOrder
            data={data.items}
            pagination={data.pagination}
            onNextPages={fetchContainerOrder}
          />
        )}
      </Paper>
    </ProtectedPage>
  )
}
